module.exports = __webpack_public_path__ + "static/img/d0992d8063a0b7b2d67d4c0d24b207e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Billing/Recharge/images/alipay.png
// module id = 2806
// module chunks = 1